import { ActivitiesEffects } from './activities-effects';
import { SchoolAssessmentsEffects } from './assessments-effects/school-assessments-effects';
import { StudentAssessmentsEffects } from './assessments-effects/student-assessments-effects';
import { CareerPathEffects } from './career-path-effects';
import { CollegePathEffects } from './college-path-effects';
import { CurrentUserEffects } from './current-user-effects';
import { DashboardEffects } from './dashboard-effects';
import { DataLoadsEffects } from './data-loads-effects';
import { DocLogsEffects } from './doc-logs-effects';
import { FlagEffects } from './flags-effects';
import { FocusEffects } from './focus-effects/focus-effects';
import { MadlibOptionsEffects } from './madlib-options-effects';
import { MilestoneEffects } from './milestone-effects';
import { PartnerOrgsEffects } from './partner-orgs-effects';
import { RollupGroupingEffects } from './rollup-grouping-effects/rollup-grouping-effects';
import { SchoolEffects } from './school-effects';
import { StudentActivitiesEffects } from './student-activities-effects';
import { StudentGroupingsEffects } from './student-groupings-effects/student-groupings-effects';
import { StudentPathsEffects } from './student-paths-effects';
import { StudentSupportsEffects } from './student-supports-effects';
import { StudentEffects } from './students-effects';
import { TileEffects } from './tile-effects/tile-effects';
import { ToggleEffects } from './toggle-effects';
import { ToolsEffects } from './tools-effects';
import { ShelterDataEffects } from './shelter-effects/shelter-effects';

export const effects: any[] = [
  StudentEffects,
  SchoolEffects,
  ToggleEffects,
  FlagEffects,
  CurrentUserEffects,
  DocLogsEffects,
  DashboardEffects,
  StudentSupportsEffects,
  MadlibOptionsEffects,
  MilestoneEffects,
  StudentPathsEffects,
  CollegePathEffects,
  CareerPathEffects,
  ToolsEffects,
  ActivitiesEffects,
  StudentActivitiesEffects,
  PartnerOrgsEffects,
  TileEffects,
  FocusEffects,
  RollupGroupingEffects,
  StudentGroupingsEffects,
  SchoolAssessmentsEffects,
  StudentAssessmentsEffects,
  DataLoadsEffects,
  ShelterDataEffects,
];

export * from './students-effects';
export * from './school-effects';
export * from './toggle-effects';
export * from './flags-effects';
export * from './current-user-effects';
export * from './doc-logs-effects';
export * from './dashboard-effects';
export * from './student-supports-effects';
export * from './madlib-options-effects';
export * from './milestone-effects';
export * from './student-paths-effects';
export * from './college-path-effects';
export * from './career-path-effects';
export * from './tools-effects';
export * from './activities-effects';
export * from './student-activities-effects';
export * from './partner-orgs-effects';
export * from './tile-effects/tile-effects';
export * from './focus-effects/focus-effects';
export * from './rollup-grouping-effects/rollup-grouping-effects';
export * from './student-groupings-effects/student-groupings-effects';
export * from './assessments-effects/school-assessments-effects';
export * from './assessments-effects/student-assessments-effects';
export * from './data-loads-effects';
export * from './shelter-effects/shelter-effects';
